import PropTypes from 'prop-types';

const titleTable = ['id', 'name', 'type', 'email', 'phone', 'address', 'translations'];
export default { titleTable }
